/**
 * @file Progressive enhancement for "Back to ..." links used within the venue
 * registration flows (e.g. "Back to all organisation details" on the
 * individual venue landing page, "Back to all sections" on the venue
 * information page).
 *
 * These links are rendered server-side with a static `href` pointing to a
 * sensible default destination (the onboarding landing page). Some of these
 * pages are also reached from other flows (e.g. the multisite "venue landing"
 * page for a specific venue), where the static destination would skip over
 * the steps the user actually took.
 *
 * To fix this without affecting the default/onboarding behaviour, we use
 * `history.back()` to retrace the user's actual navigation when possible,
 * falling back to the static `href` when there is no in-app history to go
 * back to (e.g. the page was opened directly or in a new tab).
 */
const SELECTOR = '.js-venue-registration-back-to-previous-step';

class BackToPreviousStep {
	constructor() {
		this.links = document.querySelectorAll(SELECTOR);

		if (this.links.length) {
			this.init();
		}
	}

	canGoBackInHistory() {
		return window.history.length > 1;
	}

	init() {
		this.links.forEach((link) => {
			link.addEventListener('click', (event) => {
				if (this.canGoBackInHistory()) {
					event.preventDefault();
					window.history.back();
				}
			});
		});
	}
}

const globalBackToPreviousStep = new BackToPreviousStep();

export default globalBackToPreviousStep;
